<template>
  <div class="rich-text-div">
    <div v-html="row.body" class="html-content"></div>
    <div class="file-div">
      <List size="small">
        <ListItem>
          <ListItemMeta
            :title="$t('Appendix') + $t('invoiceName') + ':'"
            :description="row.src_name"
          />
          <template slot="action">
            <Button
              type="primary"
              size="small"
              style="margin-right: 5px"
              @click="preview(1, row.src)"
            >
              {{ $t("preview") }}
            </Button>
            <Button
              type="success"
              size="small"
              @click="preview(null, row.src)"
              >{{ $t("export") }}</Button
            >
          </template>
        </ListItem>
      </List>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    row: {
      type: Object,
    },
  },
  methods: {
    preview(type, src) {
      if (type) {
        window.open(
          // "https://view.officeapps.live.com/op/view.aspx?src=" +
            this.$globalUrl +
            src
        );
      } else {
        window.open(this.$globalUrl + src, "_black");
      }
    },
  },
};
</script>

<style lang="less" scoped>
.rich-text-div {
  height: 700px;
  position: relative;
}
.html-content {
  height: 620px;
  overflow: auto;
  padding-bottom: 10px;
}
.file-div {
  position: absolute;
  bottom: 0;
  width: ~"calc(100% - 30px)";
  margin: 0 30px 0 10px;
  border: 2px solid black;
  padding: 0 10px;
}
</style>
